import { 
	CREATE_QUIZ,
	RECIPE,
	ROUTES,
	REQUESTING
} from '../constants';
import {
	requestError
} from './error';
import firebaseAdaptor from '../firebaseAdaptor';

var db = firebaseAdaptor.db;

export const showQuiz = (dispatch)=>{
	dispatch({
		type: RECIPE.READ_QUIZ,
		payload:{
			content:{
				show:true
			}
		}
	});
};

export const requestSucceeded = (dispatch,type) =>{
	dispatch({
		type,
		payload : {
			fetchingState : REQUESTING.LOADED
		}
	});
};

const dispatchUpdateQuizzes = (dispatch,getState,recipeId,quizzes) => {
	const {createQuiz} = getState();
	const {recipes} = createQuiz;
	const newRecipes = recipes.map(r=>r.id===recipeId? 
		{
			...r,
			quizzes
		} : r);
	dispatch({
		type:CREATE_QUIZ.READ_RECIPES,
		payload : {
			fetchingState : REQUESTING.LOADED,
			newRecipes
		}
	});
};

export const registQuizListener = (dispatch,recipeId,getState) => {
	return db.collection('recipes')
		.doc(recipeId)
		.collection('quizzes')
		.onSnapshot(function(querySnapshot){
			const {createQuiz} = getState();
			const {recipes} = createQuiz;
			const recipe = recipes.find(r=>r.id===recipeId);
			let quizzes = recipe.quizzes ? [...recipe.quizzes] : [];
			for(let change of querySnapshot.docChanges) {
				const quiz = Object.assign({id:change.doc.id},change.doc.data());
				if (change.type === 'added') {
					quizzes.push(quiz);
					requestSucceeded(dispatch,RECIPE.CREATE_QUIZ);
				}
				else if(change.type === 'modified'){
					quizzes = quizzes.map(q=>q.id===change.doc.id ? quiz : q);
					requestSucceeded(dispatch,RECIPE.UPDATE_QUIZ);
				}
				else if (change.type === 'removed'){
					quizzes = quizzes.filter(q=>q.id!==change.doc.id);
					requestSucceeded(dispatch,RECIPE.DELETE_QUIZ);
				}
			}
			dispatchUpdateQuizzes(dispatch,getState,recipeId,quizzes);
		});
};

export function closeQuiz(){
	return (dispatch, getState) => {
		const {location} = getState();
		const {recipeId} = location.payload;
		if(recipeId){
			dispatch({
				type:ROUTES.SHOW_RECIPE,
				payload:{
					recipeId
				}
			});
		}
		dispatch({
			type: RECIPE.CLOSE_QUIZ
		});
	};
}

export function updateQuizzes(recipe,newQuestions,setter){
	return (dispatch) =>{
		let batch = db.batch();
		for(const question of newQuestions){
			const ref = db.collection('recipes')
				.doc(recipe.id)
				.collection('quizzes')
				.doc(question.id);
			batch.update(ref, setter(question));
		}
		batch.commit().catch(function(error){
			dispatch(requestError(error));
		});
	};
}

export function addQuiz(quiz,onSucceed){
	return (dispatch, getState) => {
		const {location} = getState();
		const {recipeId} = location.payload;
		db.collection('recipes')
			.doc(recipeId)
			.collection('quizzes')
			.add(quiz)
			.then(onSucceed&&onSucceed)
			.catch(function(error) {
				dispatch(requestError(RECIPE.CREATE_QUIZ,error));
			});

	};
}

export async function getQuizzes (recipeId) {
	try{
		const querySnapshot = await db.collection('recipes').doc(recipeId).collection('quizzes').get();
		let quizes = [];
		querySnapshot.forEach(function(doc) {
			quizes.push(Object.assign({id:doc.id},doc.data()));
		});
		return quizes;
	}catch(error){
		error.action = 'Fetching quizzes';
		throw error;
	}
}

export function updateQuiz(recipeId,quizId,value,onSuccess){
	return (dispatch) => {
		db.collection('recipes')
			.doc(recipeId)
			.collection('quizzes')
			.doc(quizId)
			.set(value, {merge: true})
			.then(onSuccess&&onSuccess)
			.catch(function(error){
				dispatch(requestError(RECIPE.UPDATE_QUIZ, error));
			});
	};
}

export function deleteQuiz(quizId){
	return (dispatch, getState) => {
		const {location} = getState();
		const {recipeId} = location.payload;
		db.collection('recipes')
			.doc(recipeId)
			.collection('quizzes')
			.doc(quizId)
			.delete()
			.then(function(){
			})
			.catch(function(error) {
				dispatch(requestError(RECIPE.DELETE_QUIZ,error));
			});
	};
}